import React, { useState } from 'react';
import axios from 'axios';

const Login = ({ onLogin }) => {
  const [login, setLogin] = useState('admin');
  const [password, setPassword] = useState('admin');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(
        '/api/auth/login',
        { login, password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        onLogin({
          user: { id: response.data.user_id, role: response.data.role },
          token: response.data.token
        });
      }
    } catch (err) {
      console.error('Login error:', err);
      if (err.response) {
        setError('Ошибка: ' + (err.response.data.detail || JSON.stringify(err.response.data)));
      } else if (err.request) {
        setError('Нет подключения к серверу. Запущен ли backend?');
      } else {
        setError('Ошибка: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <h1 style={styles.title}>🚚 Логистика</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Логин"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Входим...' : 'Вход'}
          </button>
        </form>
        <p style={styles.hint}>По умолчанию: admin / admin</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #075A64 0%, #0C7281 100%)',
  },
  loginBox: {
    background: '#FEFEFA',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
    width: '300px',
  },
  title: {
    textAlign: 'center',
    color: '#042134',
    marginBottom: '30px',
  },
  input: {
    width: '100%',
    padding: '12px',
    marginBottom: '15px',
    border: '1px solid #0C7281',
    borderRadius: '5px',
    fontSize: '16px',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '12px',
    background: '#075A64',
    color: '#FEFEFA',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  error: {
    color: '#d32f2f',
    marginBottom: '15px',
    fontSize: '14px',
  },
  hint: {
    textAlign: 'center',
    color: '#666',
    fontSize: '12px',
    marginTop: '15px',
  },
};

export default Login;
